/**
 * Shows/hides the lip balm production-delay notice based on which shade is
 * currently selected. Affected variant ids come from the notice element's
 * data-affected-variants attribute (set in gwp-lip-balm-notice.liquid), so
 * this file doesn't need to change between rounds (Rosy/Cherry before,
 * Maple now) — only the Liquid snippet's data attribute and message text do.
 *
 * DETECTION:
 * Confirmed on the live page that selecting a shade updates the URL's
 * `?variant=<id>` query param (via history.pushState/replaceState, without a
 * full page reload) — that's the most reliable signal available. This reads
 * `?variant=` on load, and re-checks it three ways so nothing is missed
 * regardless of exactly how the theme triggers the URL update: (1) shortly
 * after any radio `change` event, (2) by wrapping history.pushState/
 * replaceState directly so the URL change itself triggers a re-check, and
 * (3) on `popstate` for back/forward navigation.
 *
 * CAVEAT: Shopify only adds `?variant=` to the URL once the customer
 * actively changes the selection — the default variant on first load has no
 * query param at all. So if the affected shade IS the default (as with
 * Maple here), reading the URL alone would wrongly show nothing selected.
 * data-initial-variant (set in gwp-lip-balm-notice.liquid from
 * product.selected_or_first_available_variant.id) is the fallback for that
 * case — used only when there's no `?variant=` in the URL yet.
 */
(function () {
  var notice = document.getElementById('gwp-lip-balm-notice');
  if (!notice) return;

  var affected = (notice.getAttribute('data-affected-variants') || '')
    .split(',')
    .map(function (s) {
      return s.trim();
    })
    .filter(Boolean);

  function getCurrentVariantId() {
    var params = new URLSearchParams(window.location.search);
    var fromUrl = params.get('variant');
    if (fromUrl) return fromUrl;
    return notice.getAttribute('data-initial-variant');
  }

  function refresh() {
    var current = getCurrentVariantId();
    notice.style.display = current && affected.indexOf(String(current)) !== -1 ? '' : 'none';
  }

  refresh();

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[type="radio"]')) {
      setTimeout(refresh, 100);
    }
  });

  ['pushState', 'replaceState'].forEach(function (method) {
    var original = history[method];
    history[method] = function () {
      var result = original.apply(this, arguments);
      refresh();
      return result;
    };
  });

  window.addEventListener('popstate', refresh);
})();